import { render } from "./MensMagazineWithdrawCustom.vue?vue&type=template&id=735e3604&scoped=true&ts=true"
import script from "./MensMagazineWithdrawCustom.vue?vue&type=script&lang=ts"
export * from "./MensMagazineWithdrawCustom.vue?vue&type=script&lang=ts"

import "./MensMagazineWithdrawCustom.vue?vue&type=style&index=0&id=735e3604&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src845797062/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735e3604"]])

export default __exports__